var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\r\n    font-family: 'iransans';\r\n    src: url(" + escape(require("../fonts/iransans.eot")) + ");\r\n    src: url(" + escape(require("../fonts/iransans.eot")) + "#iefix) format('embedded-opentype'),url(" + escape(require("../fonts/iransans.woff")) + ") format('woff'),url(" + escape(require("../fonts/iransans.ttf")) + ") format('truetype');\r\n    font-weight: normal;\r\n    font-style: normal\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/Projects/Hb.Bet/ServerAPI/AdminAngular/node_modules/postcss-loader?{"ident":"postcss"}!D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/assets/css/iransans.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/css/iransans.css
// module chunks = styles